import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full h-60 bg-opacity-40 bg-primary-light-blue rounded-xl" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold tracking-wide uppercase text-blue-900 pt-4 pl-4" }, "Ülesvõtete koguarv", -1)
const _hoisted_3 = {
  class: "font-semibold text-5xl tracking-wide text-gray-700 text-center mt-12",
  ref: "totalPicturesCountEl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, " 0 ", 512)
  ]))
}